module.exports = __webpack_public_path__ + "img/exhibition.39f78e0a.jpg";